import QueueAvatar from './QueueAvatar'
export default QueueAvatar
